import { useEffect, useState } from 'react';
import './../styles/App.css';
import SplashScreen from './SplashScreen';
import config from '../constants/config.js';
import { useAuth } from '../context/AuthProvider.js';

function Settings() {
    const [ availableStores , setAvailableStores ] = useState( [] );
    const [ componentLoading , setLoading ] = useState( false );
    const { userInfo } = useAuth();

    useEffect( () => {
        async function loadData() {
            setLoading( true );

            try {
                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/shops`;
                const requestSettings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                const response = await fetch( url , requestSettings );
                const data = await response.json();

                if ( data?.shopList != null ) {
                    setAvailableStores( data.shopList );
                }
            } catch ( error ) {
                console.log( error );
            } finally {
                setLoading( false );
            }
        }

        loadData();
    } , []);

    if ( componentLoading ) {
        return <SplashScreen />
    }

    return(
        <div className="settings-page">
            <h1>Settings</h1>
            <section className="settings-section">
                <div className="heading">
                    <div>
                        <h2>User Details</h2>
                        <p>View details about the currently logged in user</p>
                    </div>
                </div>
                
                <div className="card">
                    <div className="user-info">
                        <div className="user-profile">
                            <img
                                src={userInfo?.picture}
                                alt="User Avatar"
                                className="user-avatar"
                            />
                            <div className="user-details">
                                <p><strong>Name:</strong> {userInfo?.nickname || userInfo?.name }</p>
                                <p className="email">
                                    <strong>Email:</strong> 
                                    <span> {userInfo?.email} </span>
                                    {userInfo?.email_verified && (
                                        <span className="checkmark">✔</span>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="settings-section">
                <div className="heading">
                    <div>
                        <h2>Shop Details</h2>
                        <p>View the list of the shops the customizer app is currently installed on</p>
                    </div>
                </div>
                
                <div className="card">
                    <div className="heading">
                        <div className="card-title">Connected Shops</div>
                        {/* <div className="controls">
                            <button className="add-shop-btn">
                                <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0.53125C7.5 0.239062 7.25893 0 6.96429 0C6.66964 0 6.42857 0.239062 6.42857 0.53125V6.375H0.535714C0.241071 6.375 0 6.61406 0 6.90625C0 7.19844 0.241071 7.4375 0.535714 7.4375H6.42857V13.2812C6.42857 13.5734 6.66964 13.8125 6.96429 13.8125C7.25893 13.8125 7.5 13.5734 7.5 13.2812V7.4375H13.3929C13.6875 7.4375 13.9286 7.19844 13.9286 6.90625C13.9286 6.61406 13.6875 6.375 13.3929 6.375H7.5V0.53125Z" fill="white"/>
                                </svg>

                                <span style={{ paddingLeft: 5 }}>Add Shop</span>
                            </button>
                        </div> */}
                    </div>
                    {availableStores.length > 0 ? (
                        <div className="shop-table-wrap">
                            <table className="shop-table">
                                <thead>
                                    <tr>
                                        <th>Store</th>
                                        <th>Scopes</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {availableStores.map((store) => (
                                        <tr key={store.id}>
                                            <td>
                                                <a
                                                    href={`https://admin.shopify.com/store/${store.shop.replace('.myshopify.com', '')}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="shop-name"
                                                >
                                                    {store.shop}
                                                </a>
                                            </td>
                                            <td className="scopes-column">
                                                <div className="scopes-wrapper">
                                                    {store.scope.split(',').map((scope, index) => (
                                                        <span key={index} className="badge">{scope}</span>
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <a
                                                    href={`https://admin.shopify.com/store/${store.shop.replace('.myshopify.com', '')}/settings/apps/app_installations/app/node-tiny-tags-customizer-app`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <button className="uninstall-btn">Uninstall</button>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p>No shops connected.</p>
                    )}
                </div>
            </section>
        </div>
    );
}

export default Settings;